import { dom } from '@fortawesome/fontawesome-svg-core'
  ; (async () => {
    const { default: moment } = await import('moment')

    Promise.all([
      import('../../plugins/semantic/form'),
      import('../../plugins/semantic/form.scss'),
      import('../guest-selector/guest-selector'),
      import('../guest-selector/guest-selector.scss'),
    ]).then(() => {
      Promise.all([
        import(/* webpackMode: "eager" */ './book-now.scss'),
        import(/* webpackMode: "eager" */ './book-now-external.scss'),
        import('../../scripts/dbs/dbs.semantic.form'),
        import('../../plugins/semantic/input.scss'),
        import('../../plugins/semantic/label.css'),
        import('../../plugins/semantic/transition.css'),
        import('../../plugins/semantic/transition.js'),
        import('../../plugins/semantic/icon.css'),
        import('../../plugins/semantic/modal.scss'),
        import('../../plugins/semantic/popup.css'),
        import('../../plugins/semantic/dropdown.scss'),
        import('../../plugins/semantic/dropdown'),
        import('../../plugins/semantic/modal'),
        import('../../plugins/semantic/dimmer.scss'),
        import('../../plugins/semantic/dimmer'),
        import('../../plugins/daterangepicker/daterangepicker'),
        import('../../plugins/daterangepicker/daterangepicker.scss'),
        import('../../scripts/dbs/dbs.utilities.geolocation'),
        import('../../scripts/dbs/dbs.utilities.querystring'),
        import('../../plugins/semantic/search'),
        import('../../plugins/semantic/search.scss'),
        import('../../plugins/semantic/api'),
      ]).then(() => {
        $('.widget.book-now').each(function (i, el) {
          $(el).data('widget', new BookNow(el, moment))
          $(el).data('widget').init()
        })
      })
    })
  })()

function BookNow(el, moment) {
  const self = this

  self.el = $(el)
  self.tomorrow = new Date(new Date().setDate(new Date().getDate() + 1))
  self.today = new Date()
  self.maxDate = new moment().add(1, 'y').toDate()
  self.qs = new dbs.utilities.querystring()
  self.promoCodeInput = self.el.find('.promo-code.input') // NOTE 'promo code' and 'promo voucher' are not the same thing.
  self.bookNowParameter = {}

  self.guestCheckoutForm = $('.ui.form.guest-checkout-form')
  self.memberCheckoutForm = $('.ui.form.member-checkout-form')
  self.bookingCheckoutForm = $('.ui.form.booking-checkout-form')


  const checkoutPaymentWidget = $('.widget.checkout-payment').data('widget')
  const isCheckoutPaymentPage = checkoutPaymentWidget?.el.length

  const mediaBookNowDesktopLayout = window.matchMedia('(min-width: 768px)')

  self.propertyCode = self.qs.getParameter('propertyCode')
  self.index = self.qs.getParameter('index')
  self.arriveInput = self.el.find('.arrive.input')
  self.departInput = self.el.find('.depart.input')
  self.adultsInput = self.el.find('.adults.input')
  self.kidsInput = self.el.find('.kids.input')
  self.infantsInput = self.el.find('.infants.input')
  self.sort = self.qs.getParameter('sort')

  if (self.el.hasClass('available')) {
    self.bookNow = new dbs.form.genericForm()
    self.bookNow.init(self.el.find('.ui.form'))
  }

  self.handleDealApplied = function (response) {
    self.el.find('.reward-logo').hide()
    self.el.find('.members-price').hide()
    self.el.find('.deal-applied').show()
    self.el.find('.deal-special-name').text(response.DealSpecialName)
    self.el.find('.book-form .js-deal-code').val(response.DealCode)
    self.el.find('.mobile-summary-label').addClass('has-deal-applied')
  }

  self.handleDealNotApplied = function () {
    self.el.find('.reward-logo').show()
    self.el.find('.members-price').show()
    self.el.find('.deal-applied').hide()
    self.el.find('.book-form .js-deal-code').val('')
    self.el.find('.mobile-summary-label').removeClass('has-deal-applied')
  }

  self.renderDates = function () {
    // Get arrive/depart dates from query if found, else use today/tomorrow as default.
    self.arrive = self.qs.getParameter('arrive')
      ? moment(self.qs.getParameter('arrive'), 'YYYY-MM-DD').toDate()
      : self.today
    self.depart = self.qs.getParameter('depart')
      ? moment(self.qs.getParameter('depart'), 'YYYY-MM-DD').toDate()
      : self.tomorrow

    // Set display text of datepicker
    self.el
      .find('.date-range-picker')
      .removeClass('empty')
      .text(moment(self.arrive).format('DD MMM') + ' – ' + moment(self.depart).format('DD MMM'))
    // Set values on hidden inputs
    self.el.find('.arrive.input').val(moment(self.arrive).format('YYYY-MM-DD'))
    self.el.find('.depart.input').val(moment(self.depart).format('YYYY-MM-DD'))
  }

  // Runs first when widget is initialised (on page load) and subsequently on events following page load.
  self.bookPricing = function () {
    // Set widget state as loading
    self.el.addClass('loading')

    let addMembership = window.dbs.addMembershipChecked ?? false // Checks global store

    let propertyCode = self.qs.getParameter('propertyCode')
    let forceRequote = false
    self.hasFailedPreBookCheck = window.localStorage.getItem('PBCFail')

    const getDealCodeOrPromoCode = function () {
      const queryDealCode = self.qs.getParameter('dealCode')
      const bookNowPromoCode = self.promoCodeInput.val()
      const checkoutPaymentPromoCode = checkoutPaymentWidget?.promoCodeFormInput?.val()

      // TEMP Cannot apply deals/promo codes on localhost, so logging stuff to check output on dev/uat.
      if (process.env.NODE_ENV === 'development') {
        console.log('DEALCODE: queryDealCode?', queryDealCode)
        console.log('DEALCODE: bookNowPromoCode?', bookNowPromoCode)
        console.log('DEALCODE: checkoutPaymentPromoCode?', checkoutPaymentPromoCode)
      }

      if (queryDealCode && queryDealCode.length) {
        return queryDealCode
      }

      if (bookNowPromoCode && bookNowPromoCode.length) {
        return bookNowPromoCode
      }

      if (checkoutPaymentPromoCode && checkoutPaymentPromoCode.length) {
        forceRequote = true

        if (checkoutPaymentPromoCode === '__remove_promocode') {
          checkoutPaymentWidget?.promoCodeFormInput?.val('')
          return ''
        }

        return checkoutPaymentPromoCode
      }

      return ''
    }

    const data = {
      arrive: self.el.find('.arrive.input').val(),
      depart: self.el.find('.depart.input').val(),
      adults: self.el.find('.adults.input').length > 1 ? self.el.find('.adults.input')[1].value : self.el.find('.adults.input').val(),
      kids: self.el.find('.kids.input').length > 1 ? self.el.find('.kids.input')[1].value : self.el.find('.kids.input').val(),
      infants: self.el.find('.infants.input').length > 1 ? self.el.find('.infants.input')[1].value : self.el.find('.infants.input').val(),
      guests: self.el.find('.guests.input').val(),
      cabinId: self.el.attr('data-cabinid'),
      propertyCode: propertyCode,
      propertyId: self.el.attr('data-propertyid'),
      addMembership: addMembership,
      token: self.el.attr('data-token'),
      newBooking: self.el.attr('data-new') === 'True',
      isOrderCreated: self.el.attr('data-order-created') === 'True',
      isPaymentPage: self.el.attr('data-accept-payment') === 'True',
      isRemainingPaymentPage: self.el.attr('data-remaining-payment') === 'True',
      hasRewardsNumber: self.el.attr('data-has-rewards-number') === 'False',
      parentPageType: self.el.attr('data-parent-page-type'),
      dealCode: getDealCodeOrPromoCode(),
      forceRequote: forceRequote,
    }

    self.bookNowParameter.ParkId = self.el.attr('data-parkid')
    self.bookNowParameter.PropertyCode = propertyCode
    self.bookNowParameter.AccommodationId = self.el.attr('data-cabinid')
    self.bookNowParameter.Adults = self.el.find('.adults.input').val()
    self.bookNowParameter.Kids = self.el.find('.kids.input').val()
    self.bookNowParameter.Infants = self.el.find('.infants.input').val()
    self.bookNowParameter.Arrive = self.el.find('.arrive.input').val()
    self.bookNowParameter.Depart = self.el.find('.depart.input').val()
    self.bookNowParameter.DealCode = data.dealCode

    $('.checkout-breadcrumbs a').each(function (i, el) {
      // For each breadcrumb, get its params and update the param value
      // with the value of our data object, which is what we post to the booking API
      // to ensure breadcrumb params are kept up-to-date with the booking data.

      const href = $(el).attr('href')
      if (href === undefined) return
      const [path, params] = href.includes('?') ? href.split('?') : [href, undefined]
      if (params === undefined) return

      let newParams = new URLSearchParams(params)
      newParams.forEach((value, param) => {
        if (!data[param]) return
        newParams.set(param, data[param])
      })

      $(el).attr('href', `${path}?${newParams.toString()}`)
    })

    // Hide any promo invalid errors, this gets checked after API response.
    self.el.find('.promo-invalid-error').hide()

    // disable book now button.
    // It will be enabled on keypress when the inputs are valid.
    self.disableSubmitButton()

    // CW-18490 NOTE BE does not store the statue of a membership in the cart.
    // FE requires `addMembership` to be passed to the booking request as either `true` or `false`.
    // As such, BE will always respond with membership being added or removed, regardless of if it was/was not in the cart already.
    // Because of this, FE needs to determine was a membership actually added or removed from the cart, and fire the GA event respectively.
    function wasMembershipActuallyAddedRemovedFromCart(response) {
      self.wasMembershipInCart // Leave undefined
      let isMembershipInCart = response.MemberJoinPrice > 0

      // Set initial status
      if (self.wasMembershipInCart === undefined) {
        self.wasMembershipInCart = isMembershipInCart
      }

      if (isMembershipInCart !== self.wasMembershipInCart) {
        self.wasMembershipInCart = isMembershipInCart // Set new statue
        return true
      }
    }

    // Send booking data and handle response
    $.ajax({
      url: $(el).attr('data-endpoint'),
      type: $(el).attr('data-method'),
      data: JSON.stringify(data),
      dataType: 'json',
      contentType: 'application/json',
    })
      .done(function (response) {
        console.log('BOOKNOW', response)

        //## Google Push Events
        //## --------------------------
        if (process.env.NODE_ENV === 'development') {
          console.log('response.RawDataLayerEvents', response.RawDataLayerEvents)
        }

        // CW-8299 [add_to_cart, remove_from_cart] Event success of add/remove membership
        if (
          response.RawDataLayerEvents &&
          response.RawDataLayerEvents['membership'] &&
          wasMembershipActuallyAddedRemovedFromCart(response)
        ) {
          ; (function () {
            const dataLayerAsJson = JSON.parse(response.RawDataLayerEvents['membership'])
            // TODO verify data layer object
            if (process.env.NODE_ENV === 'development') {
              console.log(`CW-8299 event ${dataLayerAsJson.event}`, JSON.stringify(dataLayerAsJson, null, 2))
            }
            window.dataLayer = window.dataLayer || [] // Create a data layer
            dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object
            dataLayer.push(dataLayerAsJson)
          })()
        }

        // CW-8299 [view_item, view_cart, begin_checkout] View accommodation detail and checkout pages. Event success of checkout payment.
        // Push datalayer for all checkout pages on page load
        //
        // NOTE 'data-parent-page-type' can have the following values:
        // 'ACCOMMODATIONDETAIL', 'CHECKOUTYOURDETAILS', 'CHECKOUTCONFIRMDETAILS', 'CHECKOUTPAYMENTDETAILS'
        let dataParentPageType = self.el.attr('data-parent-page-type')
        if (dataParentPageType && response.RawDataLayerEvents && response.RawDataLayerEvents[dataParentPageType]) {
          ; (function () {
            const dataLayerAsJson = JSON.parse(response.RawDataLayerEvents[dataParentPageType])
            // TODO verify data layer object
            if (process.env.NODE_ENV === 'development') {
              console.log(`CW-8299 event ${dataLayerAsJson.event}`, JSON.stringify(dataLayerAsJson, null, 2))
            }
            window.dataLayer = window.dataLayer || [] // Create a data layer
            dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object
            dataLayer.push(dataLayerAsJson)
          })()
        }

        //## --------------------------
        //## END  Google Push Events

        //## QuoteData
        //## --------------------------

        self.bookNowParameter.QuoteData = response.QuoteData
        self.el.find('.configuration .js-quote-data').val(response.QuoteData)
        self.el.find('.mobile-configuration .js-quote-data').val(response.QuoteData)

        //## --------------------------
        //## END QuoteData

        //## Dates
        //## --------------------------

        self.el
          .find('.date-range-picker')
          .removeClass('empty')
          .text(moment(response.From).format('DD MMM') + ' – ' + moment(response.To).format('DD MMM'))

        self.el.find('.arrive.input').val(response.From)
        self.el.find('.depart.input').val(response.To)

        self.arrive = response.From ? moment(response.From, 'YYYY-MM-DD').toDate() : self.today
        self.depart = response.To ? moment(response.To, 'YYYY-MM-DD').toDate() : self.tomorrow

        self.filters = getFilterValues();
        self.pushState(self.filters)

        //## --------------------------
        //## END Dates

        //## RemainingPaymentID (accommodation detail page)
        //## --------------------------

        self.el.find('#remaining-payment-id').val(response.RemainingPaymentID)

        //## --------------------------
        //## END RemainingPaymentID (accommodation detail page)

        //## Success false: RedirectURL
        //## --------------------------

        if (response.Success == false && response.RedirectURL != null) {
          const locationParts = response.RedirectURL.split('?')
          const qs = locationParts[1]

          if (qs && qs.length > 1 && qs.toLowerCase().includes('pbcfail')) {
            const parts = qs.split(/[&;]/g)
            for (let i = parts.length; i-- > 0;) {
              if (parts[i].toLowerCase().lastIndexOf('pbcfail=', 0) !== -1) {
                parts.splice(i, 1)
              }
            }
            response.RedirectURL = locationParts[0] + '?' + parts.join('&')
            window.localStorage.setItem('PBCFail', 'true')
          }

          window.location.replace(response.RedirectURL)
          return
        }

        //## --------------------------
        //## END Success false: RedirectURL

        //## Success false: Show Message
        //## --------------------------
        else if (response.Success == false && response.Message && response.Message.length) {
          self.disableSubmitButton()

          if (!response.MessageIcon) {
            self.el.find('.message-container').html(response.Message).show()
          } else {
            self.el.find('.message-container-with-icon .message-content').html(response.Message)
            self.el.find('.message-container-with-icon').show()
          }
          // Show total price NA
          self.el.find('.total-price .price').hide()
          self.el.find('.total-price .na-price').show()

          // Show members price NA
          self.el.find('.members-price .price').hide()
          self.el.find('.members-price .na-price').show()

          self.el.find('.deal-applied').hide()
          return
        }

        //## --------------------------
        //## END Success false: Show Message

        //## Success true
        //## --------------------------
        else if (response.Success && !isCheckoutPaymentPage) {
          self.enableSubmitButton()
        }

        //## --------------------------
        //## END Success true

        //## Total price and members price (accommodation detail page)
        //## --------------------------

        if (response.TotalPrice != null && response.Availability != null && response.Availability.length > 0) {
          const initialTotalPrice = Math.trunc(response.TotalPrice).toString()
          const initialMemberPrice = Math.trunc(response.MemberPrice).toString()

          // Show total price value
          self.el.find('.total-price .na-price').hide()
          self.el.find('.total-price .price').show()
          self.el.find('.total-price .price .value').html(initialTotalPrice)

          // Show members price value
          self.el.find('.members-price .na-price').hide()
          self.el.find('.members-price .price').show()
          self.el.find('.members-price .price .value').html(initialMemberPrice)
        } else {
          // Show total price NA
          self.el.find('.total-price .price').hide()
          self.el.find('.total-price .na-price').show()

          // Show members price NA
          self.el.find('.members-price .price').hide()
          self.el.find('.members-price .na-price').show()
        }

        //## --------------------------
        //## END Total price and members price (accommodation detail page)

        //## Promo code (accommodation detail page)
        //## --------------------------

        if (response.IsPromoCodeInvalid) {
          self.el.find('.promo-invalid-error').show()
        }

        //## --------------------------
        //## END Promo code (accommodation detail page)

        if (response.CartPrice != null) {
          $('.terms-credit-card-total').html(response.CartPrice.toFixed(2))

          if (response.DepositAmount !== null && $('#PaymentId').length > 0) {
            $.ajax({
              url: $(el).attr('data-check-deposit-endpoint'),
              type: $(el).attr('data-check-deposit-method'),
              data: {
                paymentId: $('#PaymentId').val(),
                depositAmount: response.DepositAmount * 100,
              },
              dataType: 'json',
              contentType: 'application/json',
            })
              .done(function (depositResponse) {
                if (depositResponse.DepositCharges != 0) {
                  const totalDepositAmount = (response.DepositAmount + depositResponse.DepositChargeFees / 100).toFixed(
                    2,
                  )
                  const depositCreditCardFee = (depositResponse.DepositChargeFees / 100).toFixed(2)

                  $('#payment-by-deposit').next('.payment-option').show()
                  $('.credit-card-deposit').text(totalDepositAmount)
                  $('.credit-card-deposit-fee').text(depositCreditCardFee)

                  $('#payment-by-deposit').on('click', function () {
                    if ($('#totalDepositToday').length === 0) {
                      if ($('#totalBnplToday').length > 0) {
                        $('#bnplMemberFirstRow').remove()
                        $('#totalBnplToday').remove()
                      }

                      //append totalDepositAmount in the confirm and pay button
                      $('.book-now')
                        .children('svg')
                        .after(' $' + totalDepositAmount)
                      $('.book-now').children('svg').css('margin-right', '10px')
                      $('.credit-card-surcharge').html(depositCreditCardFee)
                      $('.terms-credit-card-total').html(totalDepositAmount)

                      const gdayMemberCharge = addMembership ? 50 : 0
                      const totalChargeToday = (parseFloat(totalDepositAmount) + gdayMemberCharge).toFixed(2)

                      self.el.find('.summary .line:last-child').css({
                        'font-weight': 700,
                        'border-bottom': 'none',
                      })

                      if (addMembership) {
                        self.el
                          .find('.summary')
                          .append(
                            '<div class="line" id="depositMemberFirstRow" style="margin-top:30px"><div class="col">2 Year G’DAY Rewards Membership</i></span></div><div class="col">$50.00</div></div>' +
                            '<div class="line" id="depositMemberSecondRow"><div class="col">Deposit amount (include card fee of ' +
                            (depositResponse.DepositChargeFees / 100).toFixed(2) +
                            ')</i></span></div><div class="col">' +
                            totalDepositAmount +
                            '</div></div>' +
                            '<div class="line" id="totalDepositToday"><div class="col">Total charges on your credit card</i></span></div><div class="col" id="actual-deposit-amount">' +
                            totalChargeToday +
                            '</div></div>',
                          )
                      } else {
                        self.el
                          .find('.summary')
                          .append(
                            '<div class="line" id="depositMemberSecondRow" style="margin-top:30px"><div class="col">Deposit amount (include card fee of ' +
                            (depositResponse.DepositChargeFees / 100).toFixed(2) +
                            ')</i></span></div><div class="col">' +
                            totalDepositAmount +
                            '</div></div>' +
                            '<div class="line" id="totalDepositToday"><div class="col">Total charges on your credit card</i></span></div><div class="col" id="actual-deposit-amount">' +
                            totalChargeToday +
                            '</div></div>',
                          )
                      }
                    }
                  })
                } else {
                  $('#payment-by-deposit').next('.payment-option').hide()
                }
              })
              .fail(function () {
                $('#payment-by-deposit').next('.payment-option').hide()
              })
          } else {
            $('#payment-by-deposit').next('.payment-option').hide()
          }

          // TODO handle payment options from the `checkout-payment.js` widget script.
          if (response.IsEligibleForBNPL) {
            $('#payment-by-bnpl').next('.payment-option').show()
            $('#payment-by-bnpl').on('click', function () {
              if ($('#totalBnplToday').length === 0) {
                if ($('#totalDepositToday').length > 0) {
                  $('#depositMemberFirstRow').remove()
                  $('#depositMemberSecondRow').remove()
                  $('#totalDepositToday').remove()
                }

                self.el.find('.summary .line:last-child').css({
                  'font-weight': 700,
                  'border-bottom': 'none',
                })
                if (addMembership) {
                  self.el
                    .find('.summary')
                    .append(
                      '<div class="line" id="bnplMemberFirstRow" style="margin-top:30px"><div class="col">2 Year G’DAY Rewards Membership</i></span></div><div class="col">$50.00</div></div>' +
                      '<div class="line" id="totalBnplToday"><div class="col">Total charges on your credit card</i></span></div><div class="col" id="actual-deposit-amount">$50.00</div></div>',
                    )
                } else {
                  self.el
                    .find('.summary')
                    .append(
                      '<div class="line" id="totalBnplToday" style="margin-top:30px"><div class="col">Total charges on your credit card</i></span></div><div class="col" id="actual-deposit-amount">$0.00</div></div>',
                    )
                }
              }
              if (response.CreditCardSurcharge != null) {
                $('.credit-card-surcharge').html(response.CreditCardSurcharge.toFixed(2))
              }
              $('.terms-credit-card-total').html(response.CartPrice.toFixed(2))
            })
          } else {
            $('#payment-by-bnpl').next('.payment-option').hide()
          }

          // TODO handle payment options from the `checkout-payment.js` widget script.
          $('#payment-in-full').on('click', function () {
            if ($('#totalDepositToday').length > 0) {
              $('#depositMemberFirstRow').remove()
              $('#depositMemberSecondRow').remove()
              $('#totalDepositToday').remove()
            }
            if ($('#totalBnplToday').length > 0) {
              $('#bnplMemberFirstRow').remove()
              $('#totalBnplToday').remove()
            }

            if (response.CreditCardSurcharge != null) {
              $('.credit-card-surcharge').html(response.CreditCardSurcharge.toFixed(2))
            }
            $('.terms-credit-card-total').html(response.CartPrice.toFixed(2))
          })

          $('.credit-card-total').html(response.CartPrice.toFixed(2))

          self.el.find('.cart-price .na-price').hide()
          self.el.find('.cart-price .price').show()
          self.el.find('.cart-price .price .value').html(response.CartPrice.toFixed(2))

          if (response.CartPrice === 0 && response.VoucherChargeTotal === 0) {
            window.dbs.globalEvents.emit('disable_payment_options')
          } else {
            window.dbs.globalEvents.emit('enable_payment_options')
          }

          // If a voucher covers the total cost of the order, we do not need credit card details
          if (response.VoucherChargeTotal > 0 && response.CartPrice === 0) {
            window.dbs.globalEvents.emit('disable_credit_card_validation')
          } else {
            window.dbs.globalEvents.emit('enable_credit_card_validation')
          }

          if (response.VoucherChargeTotal > 0) {
            window.dbs.globalEvents.emit('voucher_added_to_order', {
              VoucherCode: response.VoucherCode,
              VoucherType: response.VoucherType,
              VoucherAmount: response.VoucherAmount,
              VoucherChargeTotal: response.VoucherChargeTotal,
            })
          }

          if (response.VoucherChargeTotal === 0) {
            window.dbs.globalEvents.emit('voucher_removed_from_order', {
              VoucherCode: response.VoucherCode,
              VoucherType: response.VoucherType,
              VoucherAmount: response.VoucherAmount,
              VoucherChargeTotal: response.VoucherChargeTotal,
            })
          }
        } else {
          self.el.find('.cart-price .price').hide()
          self.el.find('.cart-price .na-price').show()
        }

        //## Deals and promo codes
        //## --------------------------

        // Deals UI (accommodation detail page)
        if (response.DealSpecialName) {
          console.log('DealSpecialName?', response.DealSpecialName)
          self.handleDealApplied(response)
        } else {
          self.handleDealNotApplied()
        }
        // END Deals UI (accommodation detail page)

        if (response.IsPromoCodeApplied || response.IsDiscountApplied) {
          self.promoCodeInput.val(response.DealCode)
        }

        let discountCodeFromUrl = self.qs.getParameter('dealCode')
        let promoCodeContainer = self.el.find('.promo-code-container')
        let isBookFormInCheckout = self.el.find('.book-form--disabled').length > 0
        // hide the promo code input in checkout OR if deal applied via URL params
        if (
          isBookFormInCheckout ||
          (discountCodeFromUrl && (response.IsPromoCodeApplied || response.IsDiscountApplied))
        ) {
          promoCodeContainer.hide()
        } else {
          promoCodeContainer.show()
        }

        if (discountCodeFromUrl && (response.IsPromoCodeApplied || response.IsDiscountApplied)) {
          checkoutPaymentWidget?.promoCodeComponent?.hide()
        } else {
          checkoutPaymentWidget?.promoCodeComponent?.show()
        }

        ; (function () {
          if ((!discountCodeFromUrl && response.IsPromoCodeApplied) || response.IsDiscountApplied) {
            window.dbs.globalEvents.emit('promocode_applied', {
              DealSpecialName: response.DealSpecialName,
              DealCode: response.DealCode,
            })
            return
          }

          if (response.IsPromoCodeInvalid) {
            window.dbs.globalEvents.emit('promocode_invalid', {
              DealSpecialName: response.DealSpecialName,
              DealCode: response.DealCode,
            })
            return
          }

          window.dbs.globalEvents.emit('promocode_not_applied')
        })()

        // hide the promo code input in checkout OR if deal applied via URL params
        if (
          isBookFormInCheckout ||
          (discountCodeFromUrl && (response.IsPromoCodeApplied || response.IsDiscountApplied))
        ) {
          promoCodeContainer.hide()
        } else {
          promoCodeContainer.show()
        }

        if (discountCodeFromUrl && (response.IsPromoCodeApplied || response.IsDiscountApplied)) {
          if (checkoutPaymentWidget && checkoutPaymentWidget.promoCodeComponent)
            checkoutPaymentWidget.promoCodeComponent.hide()
        }

        //## --------------------------
        //## END Deals and promo codes

        //## Credit card surcharge (checkout: payment page)
        //## --------------------------

        if (response.CreditCardSurcharge != null) {
          // Credit card surcharge displays in the payment form's terms checkbox label
          $('.credit-card-surcharge').html(response.CreditCardSurcharge.toFixed(2))
        }

        //## --------------------------
        //## END Credit card surcharge (checkout: payment page)       

        $('body').on('click mouseenter', '.calendar-price-tooltip', function () {
          const classes = $(this).attr('class').split(' ')

          for (let i = 0; i < classes.length; i++) {
            const class1 = classes[i]
            if (class1.indexOf('price') !== -1) {
              $(this).attr('data-tooltip', '$' + class1.split('_')[1])
            }
          }
        })

        //## Cart items
        //## --------------------------

        // Update summary items
        self.el.find('.summary').html('')
        $.each(response.Items, function (index, item) {
          if (item.LineItemTooltip) {
            self.el
              .find('.summary')
              .append(
                '<div class="line"><div class="col">' +
                item.Label +
                ' <span class="tooltip" data-html="' +
                item.LineItemTooltip +
                '"><i class="fa fa-info icon"></i></span></div><div class="col">' +
                item.Value +
                '</div></div>',
              )
          } else {
            self.el
              .find('.summary')
              .append(
                '<div class="line"><div class="col">' +
                item.Label +
                '</i></span></div><div class="col">' +
                item.Value +
                '</div></div>',
              )
          }

          // if (!price.TotalCabinPrice && !price.TotalSitePrice){
          //   price.hasPrice = false
          //   self.el.find('.result[data-property-code="'+ price.PropertyCode +'"] .no-results').html(price.Message).show();
          // }else{
          //   self.el.find('.result[data-property-code="'+ price.PropertyCode +'"] .no-results').hide();
          // }
          //
          // if (price.Guests <= 1){
          //   self.el.find('.result[data-property-code="'+ price.PropertyCode +'"] .price .pricing-summary .guests .label').html('guest');
          // }
          //
          // if (price.Nights <= 1){
          //   self.el.find('.result[data-property-code="'+ price.PropertyCode +'"] .price .pricing-summary .nights .label').html('night');
          // }
        })

        //## --------------------------
        //## END Cart items

        //## Show Message
        //## --------------------------

        // Show form notification message.
        if (response.Message && response.Message.length) {
          self.el.find('.message-container').html(response.Message).show()
        } else {
          self.el.find('.message-container').hide()
        }

        //## --------------------------
        //## END Show Message

        // Round up cart price to two decimal places.
        $('.checkout-payment').attr('data-cart-total-price', response.CartPrice.toFixed(2))

        //## BookingEnabled
        //## --------------------------

        // If booking is available
        if (response.BookingEnabled) {
          if (data.isPaymentPage === false) {
            // CW-12886
            // if there's a booking-checkout-form, don't remove disabled class.
            // it will be handled by form validation
            if (!$('.booking-checkout-form').length) {
              self.el.find('.submit').removeClass('disabled')
              self.el.find('.checkout-continue-btn').removeClass('disabled')
            }
          }

          if (response.AllowRefund === false) {
            $('#terms-non-refundable').removeAttr('hidden')
          } else {
            $('#terms-non-refundable').attr('hidden')
          }

          // show booking summary
          let totalPriceSummary = function () {
            let label = response.AllowRefund === true ? 'Total' : 'Total (non-refundable)'
            let tooltip = response.Tooltip
              ? `<span class="tooltip" data-html="${response.Tooltip}"><i class="fa fa-info icon"></i></span>`
              : ''
            let price = isNaN(parseFloat(response.CartPrice)) ? 'N/A' : '$' + parseFloat(response.CartPrice).toFixed(2)

            return `<div class="line line--total">
              <div class="col">${label} ${tooltip}</div>
              <div class="col total-summary-price">${price}</div>
            </div>`
          }

          self.el.find('.summary').append(totalPriceSummary())
        }

        // if booking is NOT available, disable buttons
        if (!response.BookingEnabled || self.hasFailedPreBookCheck) {
          self.disableSubmitButton()
          if (self.hasFailedPreBookCheck) {
            window.localStorage.removeItem('PBCFail')
          }
        }

        //## --------------------------
        //## END BookingEnabled

        //## Pre-book check message
        //## --------------------------

        if (self.hasFailedPreBookCheck) {
          self.el.find('.pbcfail-message-container').show()
        } else {
          self.el.find('.pbcfail-message-container').hide()
        }

        //## --------------------------
        //## END Pre-book check message

        //## Availability
        //## --------------------------

        self.availability = response.Availability

        //## --------------------------
        //## END Availability

        //## Date picker (accommodation detail page)
        //## --------------------------

        self.dateSelector.daterangepicker(
          {
            opens: 'left',
            startDate: self.arrive,
            endDate: self.depart,
            minDate: self.today,
            maxDate: self.maxDate,
            locale: 'YYYY-MM-DD',
            autoApply: true,
            isInvalidDate: function (date) {
              if (self.availability == null) {
                return false
              }

              for (let j = 0; j < self.availability.length; j++) {
                const availabilityElement = self.availability[j]
                const aDate = availabilityElement.Date

                if (moment(aDate, 'YYYY-MM-DD').isSame(date, 'day')) {
                  return false
                }
              }

              return true
            },
            isCustomDate: function (date) {
              if (self.availability == null) {
                return ['not-available']
              }

              for (let j = 0; j < self.availability.length; j++) {
                const availabilityElement = self.availability[j]
                const am = availabilityElement.Am
                const pm = availabilityElement.Pm
                const aDate = availabilityElement.Date
                const price = availabilityElement.Price

                const cellClasses = []

                if (am && pm) {
                  cellClasses.push('all-day')
                } else {
                  if (am) {
                    cellClasses.push('am')
                  }
                  if (pm) {
                    cellClasses.push('pm')
                  }
                }

                cellClasses.push('calendar-price-tooltip')
                cellClasses.push('price_' + price)

                if (moment(aDate, 'YYYY-MM-DD').isSame(date, 'day')) {
                  return cellClasses
                }
              }

              return ['not-available']
            },
          },
          function (startDate, endDate) {
            self.el
              .find('.date-range-picker')
              .removeClass('empty')
              .text(startDate.format('DD MMM') + ' – ' + endDate.format('DD MMM'))
            self.el.find('.arrive.input').val(startDate.format('YYYY-MM-DD'))
            self.el.find('.depart.input').val(endDate.format('YYYY-MM-DD'))
            self.arrive = startDate
            self.depart = endDate

            if (self.dateSelectorMobile.data('daterangepicker')) {
              self.dateSelectorMobile.data('daterangepicker').setStartDate(startDate)
              self.dateSelectorMobile.data('daterangepicker').setEndDate(endDate)
            }

            self.bookPricing()
          },
        )

        if (self.dateSelector.data('daterangepicker')) {
          self.dateSelector.data('daterangepicker').setStartDate(self.arrive)
          self.dateSelector.data('daterangepicker').setEndDate(self.depart)
        }

        self.dateSelectorMobile.daterangepicker(
          {
            opens: 'left',
            startDate: self.arrive,
            endDate: self.depart,
            minDate: self.today,
            maxDate: self.maxDate,
            locale: 'YYYY-MM-DD',
            autoApply: true,
            isInvalidDate: function (date) {
              if (self.availability == null) {
                return false
              }

              for (let j = 0; j < self.availability.length; j++) {
                const availabilityElement = self.availability[j]
                const aDate = availabilityElement.Date

                if (moment(aDate, 'YYYY-MM-DD').isSame(date, 'day')) {
                  return false
                }
              }

              return true
            },
            isCustomDate: function (date) {
              if (self.availability == null) {
                return ['not-available']
              }
              for (let j = 0; j < self.availability.length; j++) {
                const availabilityElement = self.availability[j]
                const am = availabilityElement.Am
                const pm = availabilityElement.Pm
                const aDate = availabilityElement.Date

                const cellClasses = []

                if (am && pm) {
                  cellClasses.push('all-day')
                } else {
                  if (am) {
                    cellClasses.push('am')
                  }
                  if (pm) {
                    cellClasses.push('pm')
                  }
                }

                if (moment(aDate, 'YYYY-MM-DD').isSame(date, 'day')) {
                  return cellClasses
                }
              }

              return ['not-available']
            },
          },
          function (startDate, endDate) {
            self.el
              .find('.date-range-picker')
              .removeClass('empty')
              .text(startDate.format('DD MMM') + ' – ' + endDate.format('DD MMM'))
            self.el.find('.arrive.input').val(startDate.format('YYYY-MM-DD'))
            self.el.find('.depart.input').val(endDate.format('YYYY-MM-DD'))
            self.arrive = startDate
            self.depart = endDate

            // update main date
            if (self.dateSelector.data('daterangepicker')) {
              self.dateSelector.data('daterangepicker').setStartDate(startDate)
              self.dateSelector.data('daterangepicker').setEndDate(endDate)
            }

            self.bookPricing()
          },
        )

        if (self.dateSelectorMobile.data('daterangepicker')) {
          self.dateSelectorMobile.data('daterangepicker').setStartDate(self.arrive)
          self.dateSelectorMobile.data('daterangepicker').setEndDate(self.depart)
        }

        //## --------------------------
        //## END Date picker (accommodation detail page)

        //## Tooltip
        //## --------------------------

        // init tooltips
        let tooltips = self.el.find('.tooltip')
        let popupOptions = {
          on: 'hover',
          position: 'top center',
        }

        tooltips.popup(popupOptions)

        // re-init tooltips when layout changes to fix issues
        // where popup does not show on hover if hidden via .popup('hide')
        mediaBookNowDesktopLayout.addEventListener('change', function () {
          tooltips.popup(popupOptions)
        })

        // manually hide tooltips when document scrolls
        // does not auto hide when if tooltip is in fixed or sticky element, such as book now on mobile (fixed) and desktop (sticky)
        let hideTooltips = function () {
          let tooltips = self.el.find('.tooltip.visible')
          if (tooltips.length) {
            tooltips.popup('hide')
          }
        }

        document.addEventListener('scroll', dbs.utilities.debounce(hideTooltips, 100, true))

        //## --------------------------
        //## END Tooltip
      }) // END This is the end of .done()
      .fail(function () {
        // TODO decide what happens on fail - perhaps nothing?
      })
      .always(function () {
        // See: https://fontawesome.com/v5/docs/apis/javascript/methods#dom-i2svg-params
        dom.i2svg()

        // TODO hide pricing loaders if any

        // Remove widget state as loading
        self.el.removeClass('loading')
      })
  }

  self.enableSubmitButton = function () {
    self.el.find('.submit.book-now').removeClass('disabled')
    self.el.find('.submit.mobile-book-now').removeClass('disabled')
    self.el.find('.checkout-continue-btn').removeClass('disabled')
  }

  self.disableSubmitButton = function () {
    self.el.find('.submit.book-now').addClass('disabled')
    self.el.find('.submit.mobile-book-now').addClass('disabled')
    self.el.find('.checkout-continue-btn').addClass('disabled')
  }

  self.bindSubmitButton = function () {
    const handleSubmitClick = function (e) {
      e.preventDefault()
      e.stopPropagation() // stops triggering click on .panel-toggle

      if (isCheckoutPaymentPage) {
        let bookNowButton = $(this)
        if (bookNowButton.hasClass('disabled')) {
          return
        }

        self.el.addClass('loading')
        checkoutPaymentWidget.submitForm()
      } else {
        // Accommodation detail page
        if (self.promoCodeInput.val()) {
          self.bookNowParameter.DealCode = self.promoCodeInput.val()
        } else {
          self.bookNowParameter.DealCode = self.qs.getParameter('dealCode') ?? ''
        }

        $.ajax({
          url: $(this).parents('form.booking-accommodation-form').attr('action'),
          type: $(this).parents('form.booking-accommodation-form').attr('method'),
          data: JSON.stringify(self.bookNowParameter),
          dataType: 'json',
          contentType: 'application/json',
        })
          .done(function (response) {
            if (response.RedirectUrl) {
              location = response.RedirectUrl
            }

            // CW-8299 [add_to_cart] Event success of add accommodation item to cart
            if (response.RawDataLayerEvents && response.RawDataLayerEvents['addToCart']) {
              ; (function () {
                const dataLayerAsJson = JSON.parse(response.RawDataLayerEvents['addToCart'])
                // TODO verify data layer object
                if (process.env.NODE_ENV === 'development') {
                  console.log(`CW-8299 event ${dataLayerAsJson.event}`, JSON.stringify(dataLayerAsJson, null, 2))
                }
                window.dataLayer = window.dataLayer || [] // Create a data layer
                dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object
                dataLayer.push(dataLayerAsJson)
              })()
            }
          })
          .fail(function () { })
          .always(function () { })
      }
    }

    let submitButtons = $('.widget.book-now .submit.book-now, .widget.book-now .submit.mobile-book-now')
    submitButtons.each(function () {
      $(this).click(handleSubmitClick)
    })
  }

  self.setFiltersFromUrl = function () {
    // placeholder
  }

  self.pushState = function (filters) {
    // Filter out empty values, considering falsely values
    let stateFilters = Object.fromEntries(Object.entries(filters).filter(([, value]) => value === 0 || !!value))


    var backToParkLink = $('#backToParkLink')
    if (backToParkLink.length >= 1) {
      const href = backToParkLink.attr('href').split('?')[0] + '?' + $.param(stateFilters)
      backToParkLink.attr('href', href)
      // Update URL params with new filter values, but do not reload the page.
      history.replaceState({ filters: stateFilters }, '', window.location.pathname + '?' + $.param(stateFilters))
    }
  }

  function getFilterValues() {
    let filters = {
      //propertyCode: self.propertyCode,
      //index: self.index,
      arrive: moment(self.arrive).format('YYYY-MM-DD'),
      depart: moment(self.depart).format('YYYY-MM-DD'),
      //adults: self.adultsInput,
      //kids: self.kidsInput,
      //infants: self.infantsInput,
      //sort: self.sort
      //fix for CW20-3278
      propertyCode: self.qs.getParameter('propertyCode'),
      index: self.qs.getParameter('index'),
      //arrive: self.qs.getParameter('arrive'),
      //depart: self.qs.getParameter('depart'),
      adults: self.qs.getParameter('adults'),
      kids: self.qs.getParameter('kids'),
      infants: self.qs.getParameter('infants'),
      sort: self.qs.getParameter('sort')
    }
    // NOTE Only add `dealCode` property if we have a value.
    const dealCode = self.qs.getParameter('dealCode')
    if (dealCode) {
      filters.dealCode = dealCode
    }

    return filters
  }

  self.hidePanel = function () {
    if (!self.panelToggle.hasClass('active')) return

    self.panelToggle.removeClass('active')
    self.toggleLabel.text(self.defaultText)

    self.toggleText.text("View Booking Details")
    self.chevronDown.removeAttr('hidden')
    self.chevronUp.attr('hidden', 'hidden')

    // prep transition
    let panelDOMRect = self.panelCollapse[0].getBoundingClientRect()
    self.panelCollapse.addClass('collapsing').css('height', `${panelDOMRect.height}px`)

    // start transition
    setTimeout(function () {
      self.panelCollapse.css('height', '')
    }, 0)

    // on transition end
    let transitionDuration = dbs.utilities.getTransitionDurationFromElement(self.panelCollapse)
    setTimeout(function () {
      self.panelCollapse.removeClass('collapsing').addClass('collapsed').css('height', '')
    }, transitionDuration)
  }

  self.showPanel = function () {
    if (self.panelToggle.hasClass('active')) return

    self.panelToggle.addClass('active')
    /*self.toggleLabel.text(self.activeToggleText)*/
    self.toggleText.text("Close Booking Details")
    self.chevronUp.removeAttr('hidden')
    self.chevronDown.attr('hidden','hidden')
    // start transition
    self.panelCollapse
      .removeClass('collapsed')
      .addClass('collapsing')
      .css('height', `${self.panelCollapse[0].scrollHeight}px`)

    // on transition end
    let transitionDuration = dbs.utilities.getTransitionDurationFromElement(self.panelCollapse)
    setTimeout(function () {
      self.panelCollapse.removeClass('collapsing').css('height', '')
    }, transitionDuration)
  }

  self.initPanelCollapse = function () {
    self.panelCollapse = self.el.find('.panel-collapse')
    self.panelToggle = self.el.find('.panel-toggle').not('.disable-toggle')
    self.toggleLabel = self.panelToggle.find('.js-toggle-label')
    self.defaultText = self.toggleLabel.text()
    self.activeToggleText = self.toggleLabel.attr('data-active-toggle-text')
    self.toggleText = self.el.find('.toggle-text')

    self.chevronDown = self.el.find('.toggle-chevron-down')
    self.chevronUp = self.el.find('.toggle-chevron-up')
    console.log(self.chevronDown)
    self.panelCollapse.css('height', '')

    self.panelToggle.click(function () {
      if (self.panelToggle.hasClass('active')) {
        self.hidePanel()
      } else {
        self.showPanel()
      }
    })
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('BookNow init', self)
    }

    self.initPanelCollapse()

    // Proxy button to submit the current form on the checkout page
    $('.js-checkout-continue-btn').click(function (event) {
      event.preventDefault()
      event.stopPropagation()

      let checkoutLoginTabs = $('.pt-checkout').find('.checkout-login-tabs')
      let isCheckoutDetailsPage = checkoutLoginTabs.length === 1
      if (isCheckoutDetailsPage) {
        if (self.guestCheckoutForm.is(':visible')) {
          return self.guestCheckoutForm.find('input[type="submit"], .submit.button').click()
        }

        if (self.memberCheckoutForm.is(':visible')) {
          return self.memberCheckoutForm.find('input[type="submit"], .submit.button').click()
        }

        // Fallback, if the forms above are not found
        let visibleForm = checkoutLoginTabs.find('.tab.active form')
        let submitButton = visibleForm.find('input[type="submit"], .submit.button')
        return submitButton.click()
      }

      let isCheckoutBookingPage = self.bookingCheckoutForm.length === 1
      if (isCheckoutBookingPage) {
        self.bookingCheckoutForm.find('input[type="submit"], .submit.button').click()
      }
    })

    self.disableSubmitButton()
    self.bindSubmitButton()
    self.renderDates()

    // Handle membership cart state
    // The URL param `newMember` is passed through the checkout to indicate if the membership should be included in cart for purchase.
    // This is not stored on the order in the CMS, so we need to keep up-to-date by checking the value of the URL param on each page.
    // NOTE this state is also set on membership checkbox events handled from the 'gday-rewards-cart' widget.
    window.dbs.addMembershipChecked = self.qs.getParameter('newMember') === 'True' ?? false

    // Show widget on page
    self.el.css('opacity', 1)

    self.timer = null
    self.promoCodeInput = self.el.find('.promo-code.input')
    // refresh book pricing for promo code input of backspace key
    self.promoCodeInput.keydown(function (event) {
      if (event.key === 'Backspace') {
        // trigger book pricing
        clearTimeout(self.timer)
        self.timer = setTimeout(function () {
          window.dbs.globalEvents.emit('add_promocode')
        }, 1000)
      }
    })

    // refresh book pricing for promo code input of alphanumeric characters
    self.promoCodeInput.keypress(function (event) {
      const reLettersOrNumbers = new RegExp('^[a-zA-Z0-9]+$')
      let isAlphanumeric = reLettersOrNumbers.test(String.fromCharCode(event.which))

      if (!isAlphanumeric) {
        event.preventDefault()
        return false
      }

      clearTimeout(self.timer)
      self.timer = setTimeout(function () {
        window.dbs.globalEvents.emit('add_promocode')
      }, 1000)
    })

    // refresh book pricing for promo code input of copy/paste
    self.promoCodeInput.bind('paste', function () {
      // trigger book pricing
      clearTimeout(self.timer)
      self.timer = setTimeout(function () {
        window.dbs.globalEvents.emit('add_promocode')
      }, 1000)
    })

    // Date selector
    self.dateSelector = self.el.find('.book-form .date-selector')
    self.dateSelector.on('show.daterangepicker', function () {
      self.dateSelector.addClass('open')
    })
    self.dateSelector.on('hide.daterangepicker', function () {
      self.dateSelector.removeClass('open')
    })

    // Date selector (mobile)
    self.dateSelectorMobile = self.el.find('.mobile-view .date-selector')
    self.dateSelectorMobile.on('show.daterangepicker', function () {
      self.dateSelectorMobile.addClass('open')
    })
    self.dateSelectorMobile.on('hide.daterangepicker', function () {
      self.dateSelectorMobile.removeClass('open')
    })

    window.dbs.globalEvents.subscribe('payment_form_error', function () {
      // Remove widget state as loading
      self.el.removeClass('loading')
    })

    window.dbs.globalEvents.subscribe('payment_form_is_valid', function (isValid) {
      if (isValid) {
        self.enableSubmitButton()
      } else {
        self.disableSubmitButton()
      }
    })

    window.dbs.globalEvents.subscribe('bpoint_payment_error', function () {
      // Remove widget state as loading
      self.el.removeClass('loading')
    })

    window.dbs.globalEvents.subscribe('guestselector:updated', function () {
      setTimeout(function () {
        self.bookPricing()
      }, 300)
    })

    window.dbs.globalEvents.subscribe('book_pricing', function () {
      console.log('[PUBSUB]', 'trigger_book_pricing') // TEMP
      self.bookPricing()
    })

    window.dbs.globalEvents.subscribe('addmembership', function () {
      self.bookPricing()
    })

    window.dbs.globalEvents.subscribe('removemembership', function () {
      self.bookPricing()
    })

    window.dbs.globalEvents.subscribe('add_promocode', function () {
      self.bookPricing()
    })

    window.dbs.globalEvents.subscribe('remove_promocode', function () {
      self.bookPricing()
    })

    window.dbs.globalEvents.subscribe('formsubmit', function (bookNowButton) {
      bookNowButton.parent('form').submit()
    })

    if (self.guestCheckoutForm.length) {
      self.guestCheckoutForm.data('Form').events.subscribe('Form:validation_fail', function () {
        self.hidePanel()
      })
    }

    if (self.memberCheckoutForm.length) {
      self.memberCheckoutForm.data('Form').events.subscribe('Form:validation_fail', function () {
        self.hidePanel()
      })
    }

    if (self.bookingCheckoutForm.length) {
      self.bookingCheckoutForm.data('Form').events.subscribe('Form:validation_fail', function () {
        self.hidePanel()
      })
    }

    self.bookPricing()
  }
}
